import { ControllerPaletteColor } from './__palette-color';

export enum ControllerStepperColor {
  StepAlertErrorBg = ControllerPaletteColor.Red900, // '#FDE3DF'
  StepAlertErrorFg = ControllerPaletteColor.Red500, // '#DE2D0E'
  StepAlertInfoFg = ControllerPaletteColor.Gray300, // '#4D4D4D',
  StepAlertInfoBg = ControllerPaletteColor.Gray900, // '#E5E5E5',
  StepAlertSuccessBg = ControllerPaletteColor.Minty900, // '#D7ECD8',
  StepAlertSuccessFg = ControllerPaletteColor.Minty500, // '#7AC37E',
  StepIconBg = ControllerPaletteColor.Minty300, // '#387840',
  StepLabelActiveFg = ControllerPaletteColor.Ngb500, // '#625FFF',
  StepLabelInactiveFg = ControllerPaletteColor.Gray400, // '#757575',
  StepLabelErrorFg = ControllerPaletteColor.Red300, // '#991700',
}
